// @ts-nocheck
import * as Types from '../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type ProjectItemBillDetailsQueryVariables = Types.Exact<{
  projectItemId: Types.Scalars['ID']['input'];
}>;


export type ProjectItemBillDetailsQuery = { __typename?: 'Query', projectItem: { __typename?: 'ProjectItem', id: string, displayName: string, totalCommittedCostInCents: number, billLineItems: Array<{ __typename?: 'BillLineItem', id: string, amountInCents: number, bill: { __typename?: 'Bill', id: string, tradePartnerNumber: string, isProcessingReversal: boolean, dueDate?: Types.Scalars['Date']['input'] | null | undefined, billDate: Types.Scalars['Date']['input'], type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus }, approval?: { __typename?: 'Approval', id: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, name: string } } }>, project:
      | { __typename?: 'StandaloneProject', id: string }
      | { __typename?: 'Region', id: string }
      | { __typename?: 'Market', id: string }
      | { __typename?: 'Community', id: string }
      | { __typename?: 'Subdivision', id: string }
      | { __typename?: 'Lot', id: string }
      | { __typename?: 'Structure', id: string }
      | { __typename?: 'Unit', id: string }
     } };

export type ProjectItemBillLineItemFragment = { __typename?: 'BillLineItem', id: string, amountInCents: number, bill: { __typename?: 'Bill', id: string, tradePartnerNumber: string, isProcessingReversal: boolean, dueDate?: Types.Scalars['Date']['input'] | null | undefined, billDate: Types.Scalars['Date']['input'], type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus }, approval?: { __typename?: 'Approval', id: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, name: string } } };

export type ProjectItemBillDetailsFragment = { __typename?: 'Bill', id: string, tradePartnerNumber: string, isProcessingReversal: boolean, dueDate?: Types.Scalars['Date']['input'] | null | undefined, billDate: Types.Scalars['Date']['input'], type: { __typename?: 'BillTypeDetail', code: Types.BillType }, status: { __typename?: 'BillStatusDetail', code: Types.BillStatus }, approval?: { __typename?: 'Approval', id: string, status: { __typename?: 'ApprovalStatusDetail', code: Types.ApprovalStatus, name: string } } | null | undefined, tradePartner: { __typename?: 'TradePartner', id: string, name: string } };

export const ProjectItemBillDetailsFragmentDoc = gql`
    fragment ProjectItemBillDetails on Bill {
  id
  tradePartnerNumber
  isProcessingReversal
  type {
    code
  }
  status {
    code
  }
  approval {
    id
    status {
      code
      name
    }
  }
  dueDate
  billDate
  tradePartner {
    id
    name
  }
}
    `;
export const ProjectItemBillLineItemFragmentDoc = gql`
    fragment ProjectItemBillLineItem on BillLineItem {
  id
  amountInCents
  bill {
    ...ProjectItemBillDetails
  }
}
    ${ProjectItemBillDetailsFragmentDoc}`;
export const ProjectItemBillDetailsDocument = gql`
    query ProjectItemBillDetails($projectItemId: ID!) {
  projectItem(id: $projectItemId) {
    id
    displayName
    totalCommittedCostInCents
    billLineItems {
      ...ProjectItemBillLineItem
    }
    project {
      id
    }
  }
}
    ${ProjectItemBillLineItemFragmentDoc}`;

/**
 * __useProjectItemBillDetailsQuery__
 *
 * To run a query within a React component, call `useProjectItemBillDetailsQuery` and pass it any options that fit your needs.
 * When your component renders, `useProjectItemBillDetailsQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useProjectItemBillDetailsQuery({
 *   variables: {
 *      projectItemId: // value for 'projectItemId'
 *   },
 * });
 */
export function useProjectItemBillDetailsQuery(baseOptions: ApolloReactHooks.QueryHookOptions<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables> & ({ variables: ProjectItemBillDetailsQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>(ProjectItemBillDetailsDocument, options);
      }
export function useProjectItemBillDetailsLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>(ProjectItemBillDetailsDocument, options);
        }
// @ts-ignore
export function useProjectItemBillDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>;
export function useProjectItemBillDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<ProjectItemBillDetailsQuery | undefined, ProjectItemBillDetailsQueryVariables>;
export function useProjectItemBillDetailsSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>(ProjectItemBillDetailsDocument, options);
        }
export type ProjectItemBillDetailsQueryHookResult = ReturnType<typeof useProjectItemBillDetailsQuery>;
export type ProjectItemBillDetailsLazyQueryHookResult = ReturnType<typeof useProjectItemBillDetailsLazyQuery>;
export type ProjectItemBillDetailsSuspenseQueryHookResult = ReturnType<typeof useProjectItemBillDetailsSuspenseQuery>;
export type ProjectItemBillDetailsQueryResult = Apollo.QueryResult<ProjectItemBillDetailsQuery, ProjectItemBillDetailsQueryVariables>;